import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog } from "@mui/material";

import { toUSDFormat } from "../../utils/utils";
import useStyles from "./success.styles";

import logoImg from "../../assets/imgs/crime/checkmark.png";
import cashImg from "../../assets/imgs/exchange/money.png";
import { CarsList } from "../../constants/cars";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";

interface NickCarSuccessPopupProps {
  carItemId: number;
  newCarType: number;
  damagePercent: number;
  successXpPercent: number;
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const NickCarSuccessPopup: React.FC<NickCarSuccessPopupProps> = ({
  carItemId,
  newCarType,
  damagePercent,
  successXpPercent,
  openModal,
  setOpenModal,
}) => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { myProfile } = useAppSelector((state) => state.profile);

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleListGarage = () => {
    navigate(`/garage/${myProfile.city}`);
  };

  const handleSellNow = () => {
    navigate(`/garage?sellItem=${carItemId}`);
  };

  return (
    <Dialog open={openModal} onClose={handleClose} className={classes.body}>
      <Box className={classes.modalContent}>
        <Box className={classes.closeIconBody}>
          <Button onClick={handleClose}>
            <CloseIcon htmlColor="gray" />
          </Button>
        </Box>

        <Box className={classes.contentBody}>
          <Box component={"img"} src={logoImg} className={classes.logoImg} />
          <Box className={classes.titleText}>Success!</Box>
          <Box className={classes.carDetail}>
            <Box>{CarsList[newCarType].carName}</Box>
          </Box>
          <Box>{damagePercent}% damage</Box>
          <Box
            component={"img"}
            src={`/assets/imgs/cars/${CarsList[newCarType].image}.png`}
            className={classes.carImg}
          />
          <Box className={classes.cashBox}>
            <Box component={"img"} src={cashImg} className={classes.clockImg} />
            <Box className={classes.cashAmount}>
              {toUSDFormat(
                (CarsList[newCarType].basePrice * (100 - damagePercent)) / 100
              )}
            </Box>
          </Box>

          <Box className={classes.cashBox}>
            <Box className={classes.xpAmount}>
              XP Earned: {toUSDFormat(successXpPercent, 4)}%
            </Box>
          </Box>

          <Box className={classes.buttonGroup}>
            <Button variant="contained" onClick={handleListGarage}>
              Add to garage
            </Button>
            <Button variant="contained" onClick={handleSellNow}>
              Sell now
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default NickCarSuccessPopup;
